if (!customElements.get('abok-story-tabs')) {
  customElements.define(
    'abok-story-tabs',
    class AbokStoryTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        if (this.tabs.length < 2) return;

        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, false), options);
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index), options);
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onKeydown(event, index) {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        this.select(nextIndex, true);
      }

      select(index, focus) {
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && focus) tab.focus();
        });
        this.panels.forEach((panel, panelIndex) => panel.toggleAttribute('hidden', panelIndex !== index));
      }
    },
  );
}

const abokMobileSpecQuery = window.matchMedia('(max-width: 749px)');
const syncAbokSpecs = ({ matches }) => {
  document.querySelectorAll('.abok-story-spec').forEach((spec) => {
    spec.toggleAttribute('open', !matches);
  });
};

syncAbokSpecs(abokMobileSpecQuery);
abokMobileSpecQuery.addEventListener('change', syncAbokSpecs);
